module.exports = __webpack_public_path__ + "img/logo.52341c92.jpg";